module.exports = __webpack_public_path__ + "media/img/tab-icon-5fa8dbbe.jpg";